import {Component, Input} from '@angular/core';
import {IconType} from '@pt/pt-models';

@Component({
  selector: 'pt-icon',
  template: `
    <ng-container [ngSwitch]='iconType'>
      <ng-container *ngSwitchCase='IconType.IONIC_ICON'>
        <ion-icon name='{{key}}' [ngStyle]="{'font-size': size + 'px'}" class='ion-icon' title=''></ion-icon>
      </ng-container>
      <ng-container *ngSwitchCase='IconType.SVG'>
        <ng-container *ngIf='key else DEFAULT'>
          <img [id]="'img_' + key" *ngIf='size' alt="" [src]="'assets/images/icon-svg/' + key" [ngClass]="imageClass"
               [ngStyle]="{'width': size + 'px'}" ptMissingImg>
          <img [id]="'img_' + key" *ngIf='!size' alt="" [src]="'assets/images/icon-svg/' + key" [ngClass]="imageClass"
               ptMissingImg>
        </ng-container>
      </ng-container>
    </ng-container>

    <ng-template #DEFAULT>
      <img *ngIf='size' src='assets/images/workspace/default.svg' [ngClass]="imageClass"
           [ngStyle]="{'width': size + 'px'}">
      <img *ngIf='!size' src='assets/images/workspace/default.svg' [ngClass]="imageClass">
    </ng-template>
  `,
  styles: [`
    .ion-icon {
      vertical-align: middle;
      margin: 0 2px;
      pointer-events: none;
    }
  `]
})
export class IconComponent {
  @Input() key: string;
  @Input() iconType: IconType | string = IconType.IONIC_ICON;
  @Input() size = 18;
  @Input() imageClass?: string;

  IconType = IconType;

  handleMissingImg(errorEvent: ErrorEvent) {
    (errorEvent.target as HTMLImageElement).setAttribute("src", 'assets/images/missing-img.png');
  }
}
